package com.cybersoftsolution.cybersoftsolutionweb.components.sidePanels

import androidx.compose.runtime.Composable
import com.cybersoftsolution.cybersoftsolutionweb.models.Theme
import com.cybersoftsolution.cybersoftsolutionweb.utils.Resources
import com.cybersoftsolution.cybersoftsolutionweb.utils.IdConst.sidePanelCollapsedHeight
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.cursor
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.height
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.onClick
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.position
import com.varabyte.kobweb.compose.ui.modifiers.width
import com.varabyte.kobweb.compose.ui.modifiers.zIndex
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.FaBars
import com.varabyte.kobweb.silk.components.icons.fa.IconSize
import org.jetbrains.compose.web.css.Position

import org.jetbrains.compose.web.css.deg
import org.jetbrains.compose.web.css.px

@Composable
fun SidePanelCollapsed(onMenuClick: () -> Unit = {}) {
    val context = rememberPageContext()


    Row(
        horizontalArrangement = Arrangement.Start,
        verticalAlignment = Alignment.CenterVertically,
        modifier = Modifier
//                .backgroundColor(Theme.DarkGray.rgb)
            .backgroundImage(
                linearGradient(
                angle = 35.deg,

                Theme.Primary.rgb,
                Theme.Secondary.rgb,
//                    rgb(193,15,255),


            )
            )
//                .padding(topBottom = 5.px, leftRight = 30.px)
//                .border(1.px, LineStyle.Solid, Colo.rs.Black)
//                .borderRadius(10.px)
//                .boxShadow(blurRadius = 5.px, spreadRadius = 3.px, color = Colors.DarkGray)
//                .backgroundImage(linearGradient(
//                    angle = 35.deg,
//
//                    rgb(6,0,151),
//                    rgb(130,4,255),
//                    rgb(193,15,255),
//
//
//                ))
            .fillMaxWidth()
            .height(sidePanelCollapsedHeight)
           .position(Position.Sticky)
//             .position(Position.Fixed)
            .padding(leftRight = 18.px, topBottom = 42.px)
            .zIndex(10) //posicionamiento de panel lateral sobre el contenido principal
    ){



        FaBars(
            modifier = Modifier
                .margin(leftRight = 15.px)
                .cursor(Cursor.Pointer)
                .color(selectedColor)
                .onClick { onMenuClick() },
            size = IconSize.XL,
        )

        Image(
            modifier = Modifier
//                    .backgroundColor(Theme.Primary.rgb)
                //.padding(leftRight = (-24.px), topBottom = -50.px)
//                    .height(70.px)
                .width(80.px),

            src = Resources.Images.icoLogo,
            alt = "Logo",
        )
        Image(
            modifier = Modifier
                //.padding(leftRight = (-24.px), topBottom = -50.px)
//                    .height(70.px)
                .width(210.px),

            src = Resources.Images.brand,
            alt = "Logo",
        )






    }


}



